module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/service_one-3ce261b41f5038a3f27db4c8f5a5ae3c.png";